import type { NotesFromPage } from '@/features/company/types'

/** Angular TRANSFER_LOG note-list: system notes start with `[AUDIT]`. */
export function isTransferAuditNote(notes: string | undefined | null): boolean {
  return Boolean(notes?.startsWith('[AUDIT]'))
}

/**
 * Angular `note-list.component.html`: strip `[AUDIT]` prefix when rendering TRANSFER_LOG notes.
 */
export function formatNoteBodyForDisplay(
  notes: string | undefined | null,
  fromPage: NotesFromPage,
): string {
  const raw = notes ?? ''
  if (fromPage === 'TRANSFER_LOG' && isTransferAuditNote(raw)) {
    return raw.replace('[AUDIT]', '')
  }
  return raw
}

/** Use HTML rendering for transfer audit lines (may contain markup after prefix removal). */
export function shouldRenderNoteBodyAsHtml(
  notes: string | undefined | null,
  fromPage: NotesFromPage,
  isSystem: boolean,
): boolean {
  if (fromPage === 'TRANSFER_LOG' && isTransferAuditNote(notes)) return true
  return isSystem
}

/**
 * After attachment removal the API may return the note with `notes: null` and
 * `attachments: []`. Show “Attached file has been removed.” from that payload
 * so it still appears after a full reload.
 */
export function isAttachedFileRemovedNote(note: {
  notes?: string | null
  attachments?: unknown[] | null
}): boolean {
  if (note.notes != null) return false
  const attachments = note.attachments
  return attachments == null || (Array.isArray(attachments) && attachments.length === 0)
}

/**
 * Angular transfer process log POST status when saving progress.
 * Completed only on Residents tab — not on Add & Verify for transfer_property.
 * @see frontend-app transfer-process.component.ts `saveTransferProgress()`
 */
export function resolveTransferProcessLogStatus(
  _fragment: string | null | undefined,
  selectedTab: string,
  _selectedSubTab: string,
): 'Completed' | 'Pending' {
  return selectedTab === 'residentinfo' ? 'Completed' : 'Pending'
}
